export function serialize(data) {
    return JSON.stringify(data, function (key, value) { return (value === undefined ? '__undefined__' : value); });
}
export function deserialize(str) {
    return JSON.parse(str, function (key, value) { return (value === '__undefined__' ? undefined : value); });
}
//# sourceMappingURL=serialize.js.map